import { Phone, Mic, Video } from 'lucide-react';
import { toast } from 'sonner';
import { ApiKeyCard } from './ApiKeyCard';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function IntegrationsSection({ token }) {
  return (
    <div className="space-y-6">
      {/* Ringover */}
      <ApiKeyCard
        title="Ringover"
        description="Configurez l'API Ringover pour l'ingestion des appels et SMS"
        icon={Phone}
        testIdPrefix="ringover"
        token={token}
        fields={[
          {
            key: 'api_key',
            label: 'Clé API Ringover',
            placeholder: 'Entrez votre clé API Ringover',
            secret: true,
            hint: 'Disponible dans votre dashboard Ringover',
          },
        ]}
        onSave={async (data, tkn) => {
          await axios.post(
            `${API}/persons/settings/ringover-key?api_key=${encodeURIComponent(data.api_key)}`,
            {},
            { headers: { Authorization: `Bearer ${tkn}` } }
          );
          toast.success('Clé API Ringover sauvegardée');
        }}
      />

      {/* Aircall */}
      <ApiKeyCard
        title="Aircall"
        description="Connectez Aircall pour synchroniser les appels (IVR natif)"
        icon={Phone}
        iconColor="text-sky-500"
        testIdPrefix="aircall"
        token={token}
        fields={[
          {
            key: 'api_id',
            label: 'API ID',
            placeholder: 'Votre Aircall API ID',
            secret: false,
          },
          {
            key: 'api_token',
            label: 'API Token',
            placeholder: 'Votre Aircall API Token',
            secret: true,
            hint: 'Disponible dans Aircall Dashboard > Integrations & API > API Keys',
          },
        ]}
        onSave={async (data, tkn) => {
          await axios.post(
            `${API}/persons/settings/aircall-credentials`,
            { api_id: data.api_id, api_token: data.api_token },
            { headers: { Authorization: `Bearer ${tkn}` } }
          );
          toast.success('Identifiants Aircall configurés');
        }}
      />

      {/* Microsoft Teams */}
      <ApiKeyCard
        title="Microsoft Teams"
        description="Connectez Teams pour synchroniser appels PSTN et réunions avec transcription native"
        icon={Video}
        iconColor="text-indigo-500"
        testIdPrefix="teams"
        token={token}
        fields={[
          {
            key: 'azure_tenant_id',
            label: 'Azure Tenant ID',
            placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
            secret: false,
          },
          {
            key: 'client_id',
            label: 'Client ID (Application ID)',
            placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
            secret: false,
          },
          {
            key: 'client_secret',
            label: 'Client Secret',
            placeholder: 'Votre Client Secret',
            secret: true,
            hint: 'Azure Portal > App registrations > Certificates & secrets',
          },
        ]}
        onSave={async (data, tkn) => {
          const res = await axios.post(
            `${API}/persons/settings/teams-credentials`,
            data,
            { headers: { Authorization: `Bearer ${tkn}` } }
          );
          toast.success('Identifiants Microsoft Teams configurés');
          if (res.data?.warning) {
            toast.warning(res.data.warning, { duration: 8000 });
          }
        }}
      />

      {/* ElevenLabs */}
      <ApiKeyCard
        title="ElevenLabs — Voix Premium"
        description="Clonez la voix de vos collaborateurs pour des réponses vocales réalistes"
        icon={Mic}
        testIdPrefix="elevenlabs"
        token={token}
        fields={[
          {
            key: 'api_key',
            label: 'Clé API ElevenLabs',
            placeholder: 'Entrez votre clé API ElevenLabs',
            secret: true,
            hint: 'Obtenez votre clé sur elevenlabs.io (plan gratuit disponible)',
          },
        ]}
        onSave={async (data, tkn) => {
          await axios.patch(
            `${API}/tenants/current`,
            { settings: { elevenlabs_api_key: data.api_key } },
            { headers: { Authorization: `Bearer ${tkn}` } }
          );
          toast.success('Clé API ElevenLabs sauvegardée');
        }}
      />
    </div>
  );
}
